import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="lg:w-2/5">
            <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">Guide</p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              What is OOPBuy
              <br />
              <span className="text-foreground-600 font-normal">Spreadsheet?</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              The OOPBuy spreadsheet is a curated shopping database that organizes thousands of products across multiple categories. Instead of browsing through endless websites, you get a single, organized spreadsheet with product names, prices, ratings, and availability — all updated weekly.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Think of it as your personal shopping assistant. The spreadsheet format lets you sort, filter, and compare products instantly. Whether you&apos;re looking for the latest sneakers, trending streetwear, or luxury accessories, the OOPBuy spreadsheet puts everything at your fingertips.
            </p>

            <div className="flex items-center gap-6 mb-8">
              <div className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-600">1000+</div>
                <p className="text-xs text-foreground-500 mt-1">Verified Products</p>
              </div>
              <div className="w-px h-12 bg-background-300"></div>
              <div className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-accent-600">Weekly</div>
                <p className="text-xs text-foreground-500 mt-1">Fresh Updates</p>
              </div>
            </div>

            <Link
              to="/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 underline underline-offset-4 transition-colors"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-3/5 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl overflow-hidden aspect-square">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20curated%20fashion%20items%20including%20a%20watch%20a%20small%20leather%20wallet%20and%20a%20pair%20of%20tortoiseshell%20sunglasses%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20no%20text%20no%20logos%2C%20warm%20neutral%20tones&width=600&height=600&seq=about-flatlay-v3&orientation=squarish"
                  alt="OOPBuy curated products flatlay"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden row-span-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20close%20up%20of%20a%20single%20premium%20cream%20colored%20sneaker%20on%20a%20warm%20oatmeal%20background%2C%20soft%20dramatic%20natural%20light%20from%20the%20side%2C%20editorial%20fashion%20style%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail%20texture%2C%20no%20text%20no%20logos&width=600&height=900&seq=about-sneaker-v3&orientation=portrait"
                  alt="Premium sneaker close-up"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden aspect-square">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20folded%20heathered%20gray%20hoodie%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20no%20text%20no%20logos%2C%20elevated%20composition%2C%20earthy%20neutral%20tones&width=600&height=600&seq=about-hoodie-v3&orientation=squarish"
                  alt="Folded hoodie product shot"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}